<template>
  <div v-cloak class="navbar-fixed">
    <!--Skip to content accessibility link -->
    <div>
      <a class="skip-to-content-link" href="#main-content"> Skip to content </a>
    </div>
    <!-- End skip to content accessibility link -->

    <div v-cloak class="header">
      <div v-cloak class="container">
        <nav>
          <router-link id="brand-logo" v-cloak to="/">
            <img
              v-cloak
              title="Eco Web Hosting logo"
              alt="Eco Web Hosting"
              src="@/assets/images/landing-pages/header/logo-header.svg"
            />
          </router-link>

          <div class="phone-nav">
            <span>Talk to sales</span>
            <strong>0330 912 1269</strong>
          </div>

          <ul v-cloak class="navbar-links hide-at-900">
            <li>
              <a
                href="#"
                class="sidenav-close"
                @click="toggleHostingDropdown()"
              >
                Web Hosting<i class="material-icons right">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path d="M7 10l5 5 5-5z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </i>
              </a>

              <transition name="dropdown" mode="out-in">
                <ul
                  id="hosting-dropdown"
                  @click="toggleHostingDropdown()"
                  v-cloak
                  v-if="showHostingDropdown"
                  class="dropdown-content"
                >
                  <li>
                    <router-link
                      to="/web-hosting"
                      class="nav-web-hosting sidenav-close"
                    >
                      <img
                        v-cloak
                        src="@/assets/images/nav/nav-web-hosting-icon.svg"
                        alt="Web Hosting"
                      />
                      <h3>Web Hosting</h3>
                      <p>
                        Simple, fast, and reliable fully-featured web hosting
                        packages.
                      </p>
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      to="/managed-wordpress"
                      class="nav-wordpress sidenav-close"
                    >
                      <img
                        v-cloak
                        src="@/assets/images/nav/nav-wordpress-icon.svg"
                        alt="Managed WordPress Hosting"
                      />
                      <h3>Managed WordPress Hosting</h3>
                      <p>
                        Ultra-fast hosting for the most popular CMS in the
                        world.
                      </p>
                    </router-link>
                  </li>

                  <li>
                    <router-link
                      to="/reseller-hosting"
                      class="nav-reseller sidenav-close"
                    >
                      <img
                        v-cloak
                        src="@/assets/images/nav/nav-reseller-icon.svg"
                        alt="Reseller Hosting"
                      />
                      <h3>Reseller Hosting</h3>
                      <p>
                        Build your business on our platform with no additional
                        fees.
                      </p>
                    </router-link>
                  </li>
                </ul>
              </transition>
            </li>
            <li @click="hideHostingDropdown()">
              <router-link to="/vps"> VPS </router-link>
            </li>
            <li @click="hideHostingDropdown()">
              <router-link to="/domain-names"> Domain Names </router-link>
            </li>

            <li @click="hideHostingDropdown()">
              <router-link to="/about" class="sidenav-close">
                About Us
              </router-link>
            </li>

            <li @click="hideHostingDropdown()">
              <a href="https://support.ecowebhosting.co.uk/"> Support </a>
            </li>
            <li @click="hideHostingDropdown()">
              <router-link to="/contact"> Contact </router-link>
            </li>
            <li @click="hideHostingDropdown()">
              <router-link to="/green-credentials">
                <span class="green-creds">Green Creds</span>
              </router-link>
            </li>
          </ul>

          <div class="account-basket">
            <a href="https://www.ecowebhosting.co.uk/cp/home" class="btn account">
              <img
                src="@/assets/images/landing-pages/header/account-nav.svg"
              /><span class="hide-text">My Eco</span>
            </a>
            <a href="/cp/basket" class="btn basket">
              <img src="@/assets/images/landing-pages/header/basket-nav.svg" />
            </a>
          </div>

          <div class="secondary-options">
            <span class="call-us">Talk to sales</span
            ><span><strong>0330 912 1269</strong></span>
            <country-location />
          </div>

          <!-- Mobile nav trigger -->
          <input type="checkbox" id="overlay-input" />
          <label for="overlay-input" id="overlay-button"><span></span></label>
          <div id="overlay">
            <ul>
              <li class="phone-nav">
                  <span>Talk to sales</span>
                  <strong>0330 912 1269</strong>
              </li>
              <li><a href="/web-hosting">Web Hosting</a></li>
              <li>
                <a href="/managed-wordpress">Managed Wordpress Hosting</a>
              </li>
              <li><a href="/vps">Virtual Private Servers</a></li>
              <li><a href="/reseller-hosting">Reseller Hosting</a></li>
              <li><a href="/domain-names">Domain Names</a></li>
              <li><span class="divide"></span></li>
              <li><a href="https://support.ecowebhosting.co.uk">Support</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/green-credentials">Green Credentials</a></li>
              <li>
                <a class="system-status" href="https://www.stackstatus.com/"
                  >System Status</a
                >
              </li>
              <li class="social-icons">
                <a
                  href="https://www.facebook.com/EcoWebHostingUK/"
                  rel="noopener noreferrer"
                >
                  <img
                    v-cloak
                    src="@/assets/images/landing-pages/footer/facebook-white.svg"
                    alt="Facebook"
                    rel="noopener noreferrer"
                    target="_blank"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/eco-web-hosting-ltd"
                  rel="noopener noreferrer"
                >
                  <img
                    v-cloak
                    src="@/assets/images/landing-pages/footer/linkedin-white.svg"
                    alt="LinkedIn"
                    rel="noopener noreferrer"
                    target="_blank"
                  />
                </a>
                <a
                  href="https://twitter.com/ecowebhostinguk"
                  rel="noopener noreferrer"
                >
                  <img
                    v-cloak
                    src="@/assets/images/landing-pages/footer/twitter-white.svg"
                    alt="Twitter"
                    rel="noopener noreferrer"
                    target="_blank"
                  />
                </a>
                <a
                  href="https://www.instagram.com/ecowebhostinguk/"
                  rel="noopener noreferrer"
                >
                  <img
                    v-cloak
                    src="@/assets/images/landing-pages/footer/instagram-white.svg"
                    alt="Instagram"
                    rel="noopener noreferrer"
                    target="_blank"
                  />
                </a>
              </li>
            </ul>
          </div>

          <!-- Original Sidebar trigger 
          <a
            v-cloak
            href="#"
            data-target="mobile-nav"
            class="sidenav-trigger right"
          >
            <i class="grey-text">
              <img v-cloak src="@/assets/images/burger.svg" alt="Expand menu" />
            </i>
          </a>     

          <!-- <a v-cloak href="#" data-target="mobile-nav" class="sidenav-trigger">
            <img v-cloak src="@/assets/images/burger.svg" alt="Expand menu" />
          </a> -->
        </nav>

        <!--Dropdowns -->
        <transition name="dropdown" mode="out-in">
          <!-- ABOUT DROPDOWN -->

          <ul
            id="about-dropdown"
            @click="toggleAboutDropdown()"
            v-cloak
            class="dropdown-content"
          >
            <li>
              <router-link
                to="/about-us"
                class="nav-web-hosting wh-tm-pl sidenav-close"
              >
                <h3>About the company</h3>
              </router-link>
            </li>
            <li>
              <router-link
                to="/about-us"
                class="nav-web-hosting wh-tm-pl sidenav-close"
              >
                <h3>Contact Us</h3>
              </router-link>
            </li>
          </ul>
          <!-- END ABOUT DROPDOWN -->
        </transition>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.skip-to-content-link {
  background: #f2f2f2;
  height: 30px;
  left: 0%;
  padding: 8px;
  position: fixed;
  -webkit-transform: translateY(-100%);
  transform: translateY(-100%);
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  top: -165px;
  border-radius: 3px;
  line-height: 13px;
  left: 10px;
}

.skip-to-content-link:focus {
  transform: translateY(50%);
}

@keyframes bugfix {
  from {
    padding: 0;
  }
  to {
    padding: 0;
  }
}
@-webkit-keyframes bugfix {
  from {
    padding: 0;
  }
  to {
    padding: 0;
  }
}

#overlay-button {
  display: none;
  padding: 15px 10px;
  z-index: 5;
  cursor: pointer;
  user-select: none;
  margin-left: auto;
  display: block;
  @media (min-width: 992px) {
    display:none;
    padding: 15px 5px;
  }

  span {
    height: 4px;
    width: 25px;
    border-radius: 2px;
    background-color: #333332;
    position: relative;
    display: block;
    transition: all 0.2s ease-in-out;

    &:before {
      top: -10px;
      visibility: visible;
    }
    &:after {
      top: 10px;
    }
    &:before,
    &:after {
      height: 4px;
      width: 25px;
      border-radius: 2px;
      background-color: #333332;
      position: absolute;
      content: "";
      transition: all 0.2s ease-in-out;
    }
  }
  &:hover span,
  &:hover span:before,
  &:hover span:after {
    background: #333332;
  }
}

#overlay {
  height: 100vh;
  width: 100vw;
  background: #08715e;
  z-index: 2;
  position: fixed;
  right: -100vw;
  top: 60px;
  transition: 0.2s;

  @media (min-width: 600px){
    width: 400px;
    right: -400px;
  }

  @media (min-width: 768px){
    top:80px;
  }
  

  ul {
    display: flex;
    justify-content: top;
    align-items: right;
    flex-direction: column;
    text-align: right;
    height: 100vh;
    list-style-type: none;
    margin:0;
    padding:15px 15px 0 ;

    @media (min-width: 600px){
      padding: 30px 30px;
    }

    li {
      padding: 10px 15px;

      @media (min-width:768px) {
        padding:15px;
      }

      &.phone-nav {
        color:white;
        display:block;

        @media(min-width:600px) {
          display:none;
        }
      }

      a {
        color: white;
        text-decoration: none;
        font-size: 16px;
        font-weight: bold;

        @media (min-width:768px) {
          font-size:18px;
        }
        

        &:hover {
          color: white;
        }
      }

      .divide {
        height: 3px;
        display: block;
        background: white;
        opacity: 0.3;
        border-radius: 5px;
      }

      .system-status {
        border: 1px solid white;
        /* display: block; */
        padding: 5px 10px 6px;
        border-radius: 3px;
      }

      &.social-icons {
        a{
          margin:15px 0 0 30px;
          padding: 0px;
        }
      }
    }
  }
}

input[type="checkbox"] {
  display: none;

  &:checked ~ #overlay {
    right: 0px;
    transition: 0.2s;
  }

  &:checked ~ #overlay-button {
    &:hover span,
    span {
      background: transparent;
    }
    span {
      &:before {
        transform: rotate(45deg) translate(7px, 7px);
        opacity: 1;
      }
      &:after {
        transform: rotate(-45deg) translate(7px, -7px);
      }
    }
  }
}
</style>
<script>
export default {
  name: "Navbar",
  data() {
    return {
      showHostingDropdown: false,
    };
  },
  mounted() {
    window.addEventListener("", this.hideHostingDropdown);
  },
  beforeDestroy: function () {
    window.removeEventListener("", this.hideHostingDropdown);
  },
  methods: {
    toggleHostingDropdown() {
      this.showHostingDropdown = !this.showHostingDropdown;
    },
    hideHostingDropdown() {
      this.showHostingDropdown = false;
    },
  },
};
</script>




